(function($) {
    $.fn.msxititle = function(options) {
        // build main options before element iteration
        var opts = $.extend(true, {}, $.fn.msxititle.defaults, options);

        return this.each(function() {
            var $this = $(this);
            // build element specific options
            var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;

            $this.tooltip({
                content: function() {
                    if (eOpts['html-content']) {
                        // don't escape html in tooltips
                        return $('<div/>').html($(this).prop('title')).html();
                    }
                    else {
                        // escape html in tooltips.
                        return $('<div/>').text($(this).prop('title')).html();
                    }
                },
                open: function( event, ui ) {
                    if (eOpts['html-content']) {
                        ui.tooltip.find('.icon').msxiicon();
                    }
                }
            });
        });
    };
    //
    // plugin defaults
    //
    $.fn.msxititle.defaults = {
        'html-content': false // should only be used with trusted content, otherwise we are exposed to XSS
    };
})(jQuery);